import {Component, ElementRef, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {UserService} from '../../shared/services/user/user.service';
import {Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {NgxSpinnerService} from 'ngx-spinner';

declare var $: any;

@Component({
    selector: 'app-confirmation-page',
    templateUrl: './confirmation-page.component.html',
    styleUrls: ['./confirmation-page.component.scss']
})
export class ConfirmationPageComponent implements OnInit, OnDestroy {
    userDetails = JSON.parse(localStorage.getItem('registrationPersonData'));
    captchaDetails = JSON.parse(localStorage.getItem('captchaDetailsData'));
    fileName = JSON.parse(localStorage.getItem('fileName'));
    confirmation: any;
    under18Age: any;
    isSubmitted = false;
    constructor(public router: Router,
                private formBuilder: FormBuilder,
                private userService: UserService,
                private toastr: ToastrService,
                private elementRef: ElementRef,
                private spinner: NgxSpinnerService) {
        this.getAge(this.userDetails.dateOfBirth);
        if (this.under18Age >= 18) {
            localStorage.removeItem('files');
            localStorage.removeItem('fileName');
        }
    }

    ngOnInit() {
        this.elementRef.nativeElement.ownerDocument.body.style.backgroundColor = 'white';
        if (this.userDetails === null) {
            this.router.navigate(['login']);
        }
    }

    getAge(date) {
        var dob = date;
        var today = new Date();
        var birthDate = new Date(dob);
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        this.under18Age = age;
    }

    private prepareSave(): any {
        let input: any = new FormData();
        input.append('title', this.userDetails.title);
        input.append('firstName', this.userDetails.firstName);
        input.append('middleName', this.userDetails.middleName);
        input.append('surname', this.userDetails.surname);
        input.append('dateOfBirth', this.userDetails.dateOfBirth);
        input.append('gender', this.userDetails.gender);
        input.append('email', this.userDetails.email);
        input.append('addressLine1', this.userDetails.addressLine1);
        input.append('addressLine2', this.userDetails.addressLine2);
        input.append('addressLine3', this.userDetails.addressLine3);
        input.append('county', this.userDetails.county);
        input.append('country', this.userDetails.country);
        input.append('eircode', this.userDetails.eircode);
        input.append('phoneNumber', this.userDetails.phoneNumber);
        input.append('phoneCountryCode', this.userDetails.phoneCountryCode);
        input.append('middlePhoneNumber', this.userDetails.middlePhoneNumber);
        input.append('mobilePhoneNumber', this.userDetails.mobilePhoneNumber);
        input.append('middleMobilePhoneNumber', this.userDetails.middleMobilePhoneNumber);
        input.append('mobileCountryCode', this.userDetails.mobileCountryCode);
        input.append('licenceType', this.userDetails.licenceType);
        input.append('captchaAnswer', this.captchaDetails.captchaAnswer);
        input.append('encryptedCaptchaAnswer', this.captchaDetails.encryptedCaptchaAnswer);
        input.append('apprenticeTrainerName', this.userDetails.apprenticeTrainerName);
        let file = JSON.parse(localStorage.getItem('files'));
        
        if (file) {
            let fileName = this.fileName;
            var pos = file.indexOf(';base64,');
            var type = file.substring(5, pos);
            var b64 = file.substr(pos + 8);
            var fileContent = atob(b64);
            var buffer = new ArrayBuffer(fileContent.length);
            var view = new Uint8Array(buffer);
            for (var n = 0; n < fileContent.length; n++) {
                view[n] = fileContent.charCodeAt(n);
            }
            var blob = new Blob([buffer], {type: type});
            input.append('files', blob, fileName);
        }
        return input;
    }

    downloadFile() {
        var a = document.createElement('a');
        document.body.appendChild(a);
        a.href = JSON.parse(localStorage.getItem('files'));
        a.download = this.fileName;
        a.target = '_blank';
        a.click();
    }

    doRegister() {
        this.spinner.show();
        const formModel = this.prepareSave();
        this.isSubmitted = true
        this.userService.doRegisterService(formModel).subscribe((data: any) => {
            this.spinner.hide();
            this.isSubmitted = false;
            if (data.captchaStatus === false) {
                this.toastr.error(data.message);
                this.router.navigate(['/signup']);
            } else if (data.status === true) {
                localStorage.clear();
                this.confirmation = data.message;
                $('#registrationModel').modal({
                    backdrop: 'static',
                    keyboard: false
                });
            } else {
                this.confirmation = data.message;
                $('#registrationModel').modal({
                    backdrop: 'static',
                    keyboard: false
                });
            }
        }, error => {
            if (error.status === 200) {
                return;
            } else {
                this.toastr.error('Sorry, your registration attempt was unsuccessful');
            }
            this.isSubmitted = false
            this.spinner.hide();
        });
    }

    goToLogin() {
        this.clearRegisterData();
        this.router.navigate(['/login']);
    }

    clearRegisterData() {
        localStorage.clear();
    }

    ngOnDestroy() {
        $('#registrationModel').modal('hide');
    }
}
